module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.attachments.lenght) ? _c('div', {
    staticClass: "m-t10"
  }, _vm._l((_vm.attachments), function(data) {
    return _c('div', [(data.file_url) ? _c('div', {}, [(data.file_type == 1) ? _c('div', {
      staticClass: "img-box m-t20"
    }, [_c('img', {
      attrs: {
        "src": data.file_url,
        "alt": ""
      }
    })]) : (data.file_type == 2) ? _c('div', {
      staticClass: "m-t20"
    }, [_c('theAudio', {
      attrs: {
        "src": data.file_url,
        "id": _vm.id,
        "playerObj": _vm.playerObj
      },
      on: {
        "playedObj": _vm.playedObj
      }
    })], 1) : (data.file_type == 3) ? _c('div', {
      staticClass: "video m-t20 center"
    }, [(data.file_url.indexOf('letv://')) ? _c('video', {
      attrs: {
        "src": data.file_url,
        "controls": "controls",
        "preload": "auto"
      }
    }) : _c('embed', {
      attrs: {
        "src": "http://yuntv.letv.com/bcloud.swf",
        "allowFullScreen": "true",
        "quality": "high",
        "width": "300",
        "height": "150",
        "align": "middle",
        "allowScriptAccess": "always",
        "flashvars": _vm.videoSrc(data.file_url),
        "type": "application/x-shockwave-flash"
      }
    })]) : _vm._e()]) : _vm._e()])
  })) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-49936c3e","hasScoped":false}!./~/.12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/question/attachments.vue
// module id = 186
// module chunks = 1